
import dust from "dustjs-linkedin";

import "template/widgets/loader.js";

(function(){dust.register("loader",body_0);function body_0(chk,ctx){return chk.write("<div class=\"loader-overlay hidden not-displayed\"><div class=\"loader-container\">").partial("widgets/loader",ctx,{}).write("<p class=\"loader-message\"></p></div></div>");}return body_0;})();

export default 0;
